<template>
  <div class="container">
    <div class="container-top">
      <div class="container-top-left">
        <div class="title-logo" @click="gotoDocCenter()">
          <img src="static/img/docCenter/songbai_logo.svg" alt="">
          <span class="title-logo-text">松佰商城开放平台文档中心</span>
        </div>
      </div>
      <div class="container-top-right">
        <div class="search-box" v-if="!isShowLongSearch">
          <input type="text" class="search" @focus="showLongSearch" placeholder="搜索文档关键字" v-model="searchData.searchKey">
          <img src="../../../static/img/docCenter/search_icon.svg" alt="" class="search-icon">
        </div>
        <div class="search-long-box relative" v-if="isShowLongSearch">
          <input type="text" class="search" v-model="searchData.searchKey" placeholder="搜索文档关键字" maxlength="30">
          <img src="../../../static/img/docCenter/search_icon.svg" alt="" class="search-icon" @click="search()">
          <div class="line"></div>
          <img src="static/img/docCenter/close_search.svg" @click="showSearch" alt="" class="search-icon">
          <div class="absolute history-box" v-if="historySearchList.length>0">
            <span class="history-search-text">历史搜索</span>
            <div class="history-list">
              <span class="history-item" @click="search(item)" v-for="(item,index) in historySearchList" :key="index">{{item}}</span>
            </div>
          </div>
        </div>
        <div class="console-box" @click="gotoLogin">
          <span class="console">控制台</span>
        </div>
        <div class="login-box" @click="gotoLogin">
          <span>登录 / 注册</span>
        </div>
      </div>
    </div>
    <div class="container-content">
      <div class="container-content-left">

      </div>
      <div class="container-content-center">
<!--        <div class="search-box">-->
<!--          <input type="text" class="search" placeholder="搜索文档关键字" v-model="searchData.searchKey">-->
<!--          <span @click="search()">搜索</span>-->
<!--        </div>-->
        <div v-if="searchResultList.length">
          <div v-for="(item,index) in searchResultList" :key="index">
            <div class="content-item">
              <div class="title" @click="gotoDocCenter(item.group_id,item.sort_id,item.doc_id)" v-html="item.title"></div>
              <div class="content" v-html="item.content"></div>
              <div class="from">
                <span class="from-text">来自：</span>
                <span class="from-name">{{item.from}}</span>
              </div>
            </div>
          </div>
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
        <div class="center" v-else>
          <img src="../../../static/img/docCenter/noData.png" alt="">
          <p class="noData_text">暂无查询数据哦~</p>
        </div>
      </div>
      <div class="container-content-right" v-if="docList.length">
        <div class="page-directory">推荐文档</div>
        <div class="nav">
          <p v-for="(item,index) in docList" :key="index" @click="gotoDocCenter(item.group_id,item.sort_id,item.doc_id)">
            {{item.doc_name}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {docSearchList, indexDocList} from '../../api/basisMG'
  import Pagination from "../../components/Pagination";

  export default {
    name: "docSearch",
    data() {
      return {
        loading: false, //是显示加载
        searchData: {
          pageNo: 1,
          pageSize: 10,
          searchKey: ''
        },
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        searchKey: '',
        searchResultList: [],
        docList:[],
        searchResult: '',
        isShowLongSearch: false,
        historySearchList: [],
      };
    },
    // 注册组件
    components: {
      Pagination
    },
    mounted() {
      if (this.$route.query.searchKey) {
        this.searchData.searchKey = this.$route.query.searchKey;
        this.search(this.searchData.searchKey)
      }
      this.getDocList()
    },
    methods: {
      callFather(parm) {
        this.searchData.pageNo = parm.currentPage
        this.searchData.pageSize = parm.pageSize
        this.search(this.searchData.searchKey)
      },
      gotoLogin() {
        this.$router.push({path: '/login'})
      },
      gotoDocCenter(group_id, sort_id, doc_id) {
        this.$router.push({path: '/docCenter/docCenter', query: {groupId: group_id, sortId: sort_id, docId: doc_id}})
      },
      getDocList() {
        let body = {
          groupId: '',
          sortId: '',
          status: 1,
          isRecommend:1
        }
        indexDocList(body).then(res => {
          if (res.success) {
            this.docList = res.content.rows.splice(0,5);
          }
        }).catch(err => {

        })
      },
      showLongSearch() {
        this.isShowLongSearch = true;
        if (localStorage.getItem('historyList')) {
          this.historySearchList = JSON.parse(localStorage.getItem('historyList'))
        }
      },
      showSearch() {
        this.isShowLongSearch = false;
      },
      search(item) {
        if (item) {
          this.searchData.searchKey = item;
        }
        if(this.searchData.searchKey == ''||this.searchData.searchKey == undefined||this.searchData.searchKey == null) {
          return;
        }
        if (localStorage.getItem('historyList')) {
          this.historySearchList = JSON.parse(localStorage.getItem('historyList'))
        }
        this.searchResultList = [];
        this.loading = true;
        docSearchList(this.searchData).then(res => {
          if (res.success) {
            this.loading = false;
            this.pageparm.currentPage = this.searchData.pageNo
            this.pageparm.pageSize = this.searchData.pageSize
            this.pageparm.total = res.content.total
            if(res.content.rows.length) {
              res.content.rows.forEach((item) => {
                let is_free = item.is_free ? '免费 ' : '收费 ';
                let is_limit = item.is_limit ? '有调用限制 ' : ' 无调用限制 ';
                let str = is_free + is_limit + '版本文档' + item.version + ' 更新时间：' + ' 方法名称：' + item.method + ' 使用场景：' + item.scene +
                  ' 公共参数，请求地址' + item.test_url + item.prod_url + ' 公共请求参数' + item.pubparam + ' 请求参数' + item.reqparam + ' 响应参数' + item.resparam
                this.searchResult = str;
                let arr1 = str.split(this.searchData.searchKey)
                let arr2 = item.doc_name.split(this.searchData.searchKey)
                let span = `<span style="color:#409EFF;">${this.searchData.searchKey}</span>`;
                let obj = {
                  group_id: item.group_id,
                  sort_id: item.sort_id,
                  doc_id: item.id,
                  title: arr2.join(span),
                  content: arr1.join(span),
                  from: item.group_name + ' / ' + item.sort_name + ' / ' + item.doc_name
                }
                this.searchResultList.push(obj)
              })
              if (this.historySearchList.includes(this.searchData.searchKey)) {
                localStorage.setItem('historyList', JSON.stringify(this.historySearchList))
                return;
              } else {
                if (this.historySearchList.length >= 10) {
                  this.historySearchList.pop();
                }
                this.historySearchList.unshift(this.searchData.searchKey)
                localStorage.setItem('historyList', JSON.stringify(this.historySearchList))
              }
            }
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
      }
    },
  }
</script>

<style scoped>
  .container {
    background: #fff;
    height: 100%;
  }

  .container-top {
    height: 60px;
    border-bottom: 2px solid #E6E6E6;
    display: flex;
    justify-content: space-between;
    background: #fff;
  }

  .container-top-left {
    display: flex;
    align-items: center;
  }

  .container-top-right {
    display: flex;
    align-items: center;
  }

  .title-logo {
    display: flex;
    align-items: center;
    margin-left: 30px;
    cursor: pointer;
  }

  .title-logo-text {
    margin-left: 4px;
    font-weight: 700;
    font-size: 16px;
    color: #333;
  }

  .login-box span {
    display: inline-block;
    width: 132px;
    line-height: 60px;
    height: 60px;
    background: #409EFF;
    text-align: center;
    font-size: 15px;
    color: #fff;
    cursor: pointer;
  }

  .console {
    color: #409EFF;
    font-size: 15px;
    margin: 0 40px 0 50px;
    padding: 4px 8px;
    font-weight: 700;
  }

  .console:hover {
    cursor: pointer;
    border-radius: 2px;
    background: #F4F4F4;
  }

  .search-box {
    display: flex;
    align-items: center;
    background: #F4F4F4;
    width: 216px;
    height: 32px;
  }

  .search-box .search {
    border: none;
    height: 30px;
    outline: none;
    width: 164px;
    padding-left: 8px;
    background: #F4F4F4;
  }

  .search-icon {
    margin-left: 12px;
    cursor: pointer;
  }

  .container-content {
    width: 1350px;
    margin: 40px auto;
    display: flex;
  }

  .container-content-left {
    width: 170px;
  }

  .container-content-center {
    width: 900px;
    margin-left: 60px;
  }

  .container-content-right {
    margin-left: 70px;
    position: fixed;
    left: 50%;
    margin-left: 500px;
  }

  /deep/ .el-collapse {
    border: 0;
  }

  /deep/ .el-collapse-item__header {
    border: 0;
    height: 36px;
    line-height: 36px;
  }

  /deep/ .el-collapse-item__wrap {
    border: 0;
  }

  /deep/ .el-collapse-item__content {
    padding-bottom: 0;
  }

  /deep/ .el-collapse-item__content div {
    height: 36px;
    line-height: 36px;
    text-align: center;
    display: -webkit-box;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .api_message_box .line {
    width: 3px;
    height: 20px;
    background: #ccc;
    border-radius: 99px;
    margin-right: 20px;
    display: block;
  }

  .content-item {
    margin-top: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #E6E6E6;
  }

  .content {
    display: -webkit-box;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .container-content-center .search-box {
    width: 100%;
    height: 40px;
    justify-content: space-between;
  }

  .container-content-center .search-box .search {
    width: 700px;
  }

  .container-content-center .search-box span {
    display: inline-block;
    width: 90px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    color: #fff;
    background: #409EFF;
    cursor: pointer;
  }

  .content-item .title {
    font-size: 20px;
    color: #333;
    font-weight: 700;
    margin-bottom: 15px;
    cursor: pointer;
  }

  .content-item .content {
    color: #666;
    line-height: 24px;
  }

  .content-item .from {
    margin-top: 10px;
  }

  .from-text {
    color: #666;
  }

  .from-name {
    color: #999;
  }

  .page-directory {
    line-height: 32px;
  }

  .nav {
    margin-left: 15px;
    margin-top: 5px;
  }

  .nav p {
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    border-left: 1px solid #ccc;
    padding-left: 20px;
    color: #666;
    cursor: pointer;
    width: 200px;
    display: -webkit-box;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .search-long-box {
    display: flex;
    align-items: center;
    background: #F4F4F4;
    width: 560px;
    height: 32px;
  }

  .search-long-box .search {
    border: none;
    height: 30px;
    outline: none;
    width: 470px;
    padding-left: 8px;
    background: #F4F4F4;
  }

  .search-box .search {
    border: none;
    height: 30px;
    outline: none;
    width: 164px;
    padding-left: 8px;
    background: #F4F4F4;
  }

  .history-box {
    width: 560px;
    background: #fff;
    top: 36px;
    left: 0px;
    border-radius: 3px;
    z-index: 99;
    box-shadow: 5px 5px 10px 0px rgba(51, 51, 51, 0.1);
  }

  .history-list {
    padding-left: 15px;
  }

  .history-item {
    display: inline-block;
    padding: 5px 10px;
    background: #F4F4F4;
    margin-right: 12px;
    color: #666;
    font-size: 12px;
    margin-bottom: 10px;
    cursor: pointer;
  }

  .history-item:hover {
    background: rgba(64, 158, 255, 0.1);
    color: #409EFF;
  }

  .history-search-text {
    display: inline-block;
    font-size: 14px;
    color: #666666;
    padding: 15px 0 10px 15px;
  }

  .absolute {
    position: absolute;
  }

  .line {
    width: 1px;
    height: 12px;
    background: #999999;
    margin-left: 12px;
  }

  .noData_text {
    color: #999;
    margin-top: 30px;
    font-size: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/views/docCenter/docSearch.vue